export function anotherOption() {
    const fields = document.querySelectorAll('.form-radios-alt');
    if (fields)
        fields.forEach((field) => {
            const radios = field.previousElementSibling;
            radios.addEventListener('change', () => {
                const checked = radios.querySelector('input:checked');
                toggle(field, checked.value);
            });
        });
    const toggle = (field, value) => {
        if (value != '-1') {
            field.classList.remove('open');
        }
        else {
            field.classList.add('open');
        }
    };
}
